export default __webpack_public_path__ + "static/media/Initiate's Boots of the Burning Disc.9552d8c2.jpg";